
    import './styles.scoped.css';
    export default {
  "trigger-button": "awsui_trigger-button_dwuol_102fj_9",
  "placeholder": "awsui_placeholder_dwuol_102fj_13",
  "disabled": "awsui_disabled_dwuol_102fj_18",
  "item": "awsui_item_dwuol_102fj_22",
  "checkbox": "awsui_checkbox_dwuol_102fj_26",
  "option-group": "awsui_option-group_dwuol_102fj_35",
  "filter": "awsui_filter_dwuol_102fj_39",
  "trigger": "awsui_trigger_dwuol_102fj_9",
  "layout-strut": "awsui_layout-strut_dwuol_102fj_50",
  "list-bottom": "awsui_list-bottom_dwuol_102fj_56",
  "selected-icon": "awsui_selected-icon_dwuol_102fj_60",
  "show-label-tag": "awsui_show-label-tag_dwuol_102fj_65",
  "inline-token-trigger": "awsui_inline-token-trigger_dwuol_102fj_69",
  "inline-token-list": "awsui_inline-token-list_dwuol_102fj_76",
  "inline-token-hidden-placeholder": "awsui_inline-token-hidden-placeholder_dwuol_102fj_90",
  "inline-token-counter": "awsui_inline-token-counter_dwuol_102fj_96",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_dwuol_102fj_100",
  "inline-label-wrapper": "awsui_inline-label-wrapper_dwuol_102fj_104",
  "inline-label": "awsui_inline-label_dwuol_102fj_100",
  "inline-label-disabled": "awsui_inline-label-disabled_dwuol_102fj_129",
  "inline-label-inline-tokens": "awsui_inline-label-inline-tokens_dwuol_102fj_133",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_dwuol_102fj_138"
};
  